import React, { useState, useMemo } from 'react';
import { View } from 'react-native';
import { createPortal } from 'react-dom';
import ToastContext from './context';
import Toast from './Toast';
const toastStyle = {
    position: 'absolute',
    zIndex: 10000,
};
// ??? - Use UUID v4 instead?
function generateUEID() {
    let first = (Math.random() * 46656) || 0;
    let second = (Math.random() * 46656) || 0;
    first = ('000' + first.toString(36)).slice(-3);
    second = ('000' + second.toString(36)).slice(-3);
    return first + second;
}
export var Orientations;
(function (Orientations) {
    Orientations["BOTTOM_RIGHT"] = "bottom right";
    Orientations["TOP_RIGHT_MEETINGS"] = "top right meeting";
    Orientations["TOP_RIGHT"] = "top right";
    Orientations["TOP_RIGHT_MOBILE"] = "top right mobile";
})(Orientations || (Orientations = {}));
function getOrientation(orientation) {
    switch (orientation) {
        case Orientations.TOP_RIGHT: {
            return {
                top: 70,
                right: 16,
                bottom: undefined,
            };
        }
        case Orientations.TOP_RIGHT_MEETINGS: {
            return {
                top: 40,
                right: 40,
                bottom: undefined,
            };
        }
        case Orientations.TOP_RIGHT_MOBILE: {
            return {
                top: 10,
                right: 10,
                bottom: undefined,
            };
        }
        case Orientations.BOTTOM_RIGHT: {
            return {
                bottom: 40,
                right: 40,
            };
        }
        default: {
            return {
                bottom: 40,
                right: 40,
            };
        }
    }
}
function withToastProvider(Component) {
    function WithToastProvider(props) {
        const [toasts, setToasts] = useState([]);
        const [orientation, setOrientation] = useState(Orientations.BOTTOM_RIGHT);
        const add = (component, orientation, removable, timeoutMs) => {
            const id = generateUEID();
            setToasts([{ id, component, removable: !!removable, timeoutMs: timeoutMs ?? 3000 }, ...toasts]);
            setOrientation(orientation);
            return id;
        };
        const remove = (id) => setToasts(toasts.filter((t) => t.id !== id));
        const providerValue = useMemo(() => { return { add, remove }; }, [toasts]);
        return (
        // @ts-ignore
        <ToastContext.Provider value={providerValue}>
        <Component {...props}/>

        {createPortal(<View style={[toastStyle, getOrientation(orientation)]}>
            {toasts.map(t => (<Toast key={t.id} remove={() => remove(t.id)} timeoutMs={t.timeoutMs} removable={t.removable}>
                {t.component}
              </Toast>))}
          </View>, document.body)}
      </ToastContext.Provider>);
    }
    return WithToastProvider;
}
export default withToastProvider;
//# sourceMappingURL=withToastProvider.js.map